import React, { useRef } from "react";
import ShCheckoutBraintree from "./braintree/shCheckoutBraintree";
import ShButton from "../../../../components/button/shButton";

import styles from "../../checkout-generic/payment/shPaymentAction.module.scss";

import CreditCardLightSVG from "../../../../public/icons/payment/creditcardButtonIcon.svg";
import ShoppingCartSVG from "../../../../public/icons/payment/sepaButtonIcon.svg";
import { ShCheckoutReturnPolicyInfo } from "../helper/components/shCheckoutReturnPolicyInfo";
import ShPaymentFriendlyName from "../payment-choose/shPaymentFriendlyName";
import ShCheckoutBraintreeLoadingIndicator from "./braintree/shCheckoutBraintreeLoadingIndicator";
import { Elements } from "@stripe/react-stripe-js";
import ShCheckoutStripePaymentButtons from "./stripe/shCheckoutStripePaymentButtons";
import ShCheckkoutStripeCreditcard from "./stripe/shCheckkoutStripeCreditcard";
import ShCheckoutStripeSEPA from "./stripe/shCheckoutStripeSEPA";
import { loadStripe } from "@stripe/stripe-js";
import { getStripePublicKey } from "../../../../helper/constants/uri";
import ShNewModalWrapper from "../../../../components/modal/shNewModalWrapper";

const stripePromise = loadStripe(getStripePublicKey());

export const ShCheckoutGenericPayment = ( {
                                              children,
                                              modalHeader, hideModal,
                                              totalPrice,
                                              paymentMethod,
                                              paymentSucceeded = (transactionId) => { },
                                              title,
                                              braintreeUrl, stripeUrl, postData,

                                              showFreeBuy = false,
                                              freeBuyed =  () => { }

                                           } ) => {

    const creditcardRef = useRef<any>();
    const sepaRef = useRef<any>();

    let footerButton = null;

    if (showFreeBuy) {
        footerButton = <ShButton variant={"primary"}
                                 onClick={freeBuyed}
                                 className={"w-100 mb-2 " +  styles.freeBg}>
            Jetzt kostenlos kaufen
        </ShButton>;
    } else if (paymentMethod === "paypal") {
       footerButton = <ShCheckoutBraintree
            paymentSucceeded={ (res: any) => paymentSucceeded(res?.transactionId) }
            postData={postData}
            url={braintreeUrl} />
    } else {
        footerButton = <ShButton className={"w-100 mb-2 " +
            ((paymentMethod === 'creditcard') ? styles.creditcardBg : '') +
            ((paymentMethod === 'sepa') ? styles.sepaBg : '')
        }
                                 variant={"dark"}
                                 onClick={
                                     () => {
                                         if (paymentMethod === "creditcard") {
                                             creditcardRef.current?.processPayment();
                                         } else if (paymentMethod === "sepa") {
                                             sepaRef.current?.processPayment();
                                         }
                                     }
                                 }
        >

            { paymentMethod === 'creditcard' && <CreditCardLightSVG className={"svg-light text-white svg-24" } />}
            { paymentMethod === 'sepa' && <ShoppingCartSVG className={"svg-light text-white svg-24"} />}

            Jetzt sicher bezahlen

        </ShButton>
    }

    const footer = <>
            <p className="small-text opacity-50 mb-3 mt-5">
                Mit deinem Kauf akzeptierst du die <a href="/inhalt/allgemeine-geschaeftsbedingungen/" target={"_blank"} className={"c-pointer text-underline"}>AGB</a>
                <span dangerouslySetInnerHTML={ { __html: "&nbsp;"} } />  und die <a href="/inhalt/datenschutz/" target="_blank" className={"c-pointer text-underline"}>Datenschutzbedingungen.</a>
            </p>

            { footerButton }

            <ShCheckoutReturnPolicyInfo />

        </>

    // @ts-ignore
    return <ShNewModalWrapper title={<>Bezahlen mit <ShPaymentFriendlyName paymentMethod={paymentMethod} /></>}
                              header={modalHeader}
                              onRequestClose={hideModal}
                              footer={footer}>

        <ShCheckoutBraintreeLoadingIndicator />


        {(paymentMethod === 'creditcard') &&
            <Elements stripe={stripePromise}>
                <ShCheckoutStripePaymentButtons
                    url={stripeUrl}
                    postData={postData}
                    paymentSucceeded={ (res) => paymentSucceeded(res?.transactionId) }

                    label={title}
                    totalPrice={totalPrice}
                />

                <ShCheckkoutStripeCreditcard
                    ref={creditcardRef}
                    paymentSucceeded={ (res) => paymentSucceeded(res?.transactionId) }

                    url={stripeUrl}
                    postData={postData}
                />

            </Elements>
        }

        {(paymentMethod === 'sepa') &&
            <Elements stripe={stripePromise}>
                <ShCheckoutStripeSEPA
                    ref={sepaRef}
                    paymentSucceeded={ (res) => paymentSucceeded(res?.transactionId) }
                    url={stripeUrl}
                    postData={postData}
                />
            </Elements>
        }

        { children }


    </ShNewModalWrapper>

};
